import { COMPANY, NAV } from "@/data/site";

export default function Footer() {
  return (
    <footer className="relative bg-obsidian border-t border-white/10 pt-16 overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-2">
              <span className="font-display text-4xl leading-none text-spartanorange">SPARTAN</span>
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-spartangreen">packaging · automation</span>
            </div>
            <p className="mt-5 text-white/55 text-sm max-w-sm leading-relaxed">
              {COMPANY.tagline}. Complete packaging machinery solutions —
              engineered, installed and supported across Malaysia and the region.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/45 mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-white/70 hover:text-spartanorange transition-colors text-sm" data-testid={`footer-nav-${n.label.toLowerCase()}`}>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/45 mb-5">Get in Touch</p>
            <ul className="space-y-3 text-sm">
              <li><a href={`tel:${COMPANY.phone}`} className="text-white/70 hover:text-spartanorange transition-colors">{COMPANY.phone}</a></li>
              <li><a href={`mailto:${COMPANY.email}`} className="text-white/70 hover:text-spartanorange transition-colors">{COMPANY.email}</a></li>
              <li className="text-white/50 leading-relaxed">{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 py-6 border-t border-white/10 font-mono text-[11px] tracking-wide uppercase text-white/40">
          <span>© {COMPANY.legal} — {COMPANY.since}. All rights reserved.</span>
          <span>© {COMPANY.legal2} — {COMPANY.since}.</span>
        </div>
      </div>

      {/* Massive wordmark */}
      <div className="select-none pointer-events-none leading-none -mb-4 md:-mb-8">
        <p className="font-display uppercase tracking-tighter text-center text-[22vw] text-white/[0.04]">
          SPARTAN
        </p>
      </div>
    </footer>
  );
}
